import { ValidationWidgetRule } from '@tcs/common/components/atoms/ValidationWidget/ValidationWidgetRule';

export const passwordRules: ValidationWidgetRule<string>[] = [
  {
    name: 'length',
    message: 'Be between 8 and 64 characters in length',
    test: (value) => value && value.length >= 8 && value.length <= 64,
  },
  {
    name: 'lowercase',
    message: 'Contain lowercase letter (e.g. a-z)',
    test: (value) => value && /[a-z]/.test(value),
  },
  {
    name: 'uppercase',
    message: 'Contain uppercase letter (e.g. A-Z)',
    test: (value) => value && /[A-Z]/.test(value),
  },
  {
    name: 'number',
    message: 'Contain number (e.g. 0-9)',
    test: (value) => value && /\d/.test(value),
  },
  {
    name: 'special',
    message: 'Contain special character (e.g. !@#$^%*()_+|~-=\'{}[]:";<>?,./)',
    test: (value) => value && /[!@#$^%*()_+|~\-=`{}[\]:";'<>?,./]/.test(value),
  },
];
